import { ListingTopSectionAction } from "./ListingTopSectionAction";
import { Bookmark, BookmarkBorder } from "@mui/icons-material";
import { useBlogCardWebContext } from "../../../blog/blogCard";
import useUser from "../../../../hooks/user/useUser";
import { useSnackbarContext } from "../../../global/snackbar/SnackbarProvider";
import { useIsBlogSaved } from "../../../../hooks/blogs";
import { putBlog, removeBlog } from "../../../../api/listings";
import { ErrorSnackbar } from "../../../global/snackbar";

export const ListingSaveBlog = () => {
  const { state, dispatch } = useBlogCardWebContext();
  const { setSnackbar } = useSnackbarContext();
  const { user } = useUser();
  const hasVisibility = !!state.blog.visibility;
  const listingHasVisibilityPremium = hasVisibility
    ? state.blog.visibility.find((item) => item === "premium")
    : null;
  const providerWithPremiumContent =
    user?.subscription_data?.subscriptionPlan.subscriptionPlanPaymentProviders.find(
      (item) => item.premiumContent === true,
    );
  const showSave = !!(
    listingHasVisibilityPremium && providerWithPremiumContent
  );
  const disabled = !user?.token || !showSave;

  useIsBlogSaved({ blog: state.blog });

  const handleSave = async () => {
    try {
      dispatch({ isSaved: true });
      await putBlog(user, state.blog.id);
    } catch (e) {
      const error = e as Error;
      setSnackbar(<ErrorSnackbar message={error.message} />);
    }
  };

  const handleRemove = async () => {
    try {
      dispatch({ isSaved: false });
      await removeBlog(user, state.blog.id);
    } catch (e) {
      const error = e as Error;
      setSnackbar(<ErrorSnackbar message={error.message} />);
    }
  };

  if (state.isSaved == null || !user?.token) {
    return;
  }

  if (state.isSaved) {
    return (
      <ListingTopSectionAction
        onClick={() => void handleRemove()}
        startIcon={<Bookmark />}
        disabled={disabled}
      >
        Saved
      </ListingTopSectionAction>
    );
  }

  return (
    <ListingTopSectionAction
      onClick={() => void handleSave()}
      startIcon={<BookmarkBorder />}
      disabled={disabled}
    >
      Save
    </ListingTopSectionAction>
  );
};
